import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import { Box, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import useAPI from "../api/hooks/useAPI";
import useColors from "../api/hooks/useColors";
import CustomToolTip from "./CustomTooltip";

const CustomCopyButton = ({
  copyTitle,
  copyText,
  sx = {},
  width = "16px",
  label = null,
  iconColor = null,
  labelColor = null,
  ...props
}) => {
  const { trackEvent } = useAPI();
  const colors = useColors();

  const initialTitle = (
    <Typography variant="caption" sx={{ color: colors.common_black }}>
      Copy {copyTitle} to clipboard
    </Typography>
  );
  const [tooltipTitle, setTooltipTitle] = useState(initialTitle);

  const handleCopy = (e) => {
    trackEvent("User Copied " + copyTitle + " to Clipboard");
    navigator.clipboard.writeText(copyText).then(() => {
      setTooltipTitle(
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <DoneRoundedIcon sx={{ color: colors.success_main, width: "18px" }} />
          <Typography variant="caption" sx={{ color: colors.common_black }}>
            Copied
          </Typography>
        </Box>
      );
      setTimeout(() => {
        setTooltipTitle(initialTitle);
      }, 1500);
    });
  };

  const handleMouseEnter = () => {
    setTooltipTitle(initialTitle);
  };

  return (
    <CustomToolTip title={tooltipTitle} placement="top">
      <IconButton
        onClick={handleCopy}
        onMouseEnter={handleMouseEnter}
        disableRipple
        {...props}
        sx={{
          alignSelf: "flex-start",
          padding: "4px",
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: colors.grey_8percent,
          },
          ...sx,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <ContentCopyIcon
          sx={{
            width: width,
            height: width,
            ...(iconColor && { color: iconColor }),
          }}
        />
        {label && (
          <Typography
            variant="caption"
            sx={{ ...(labelColor && { color: labelColor }) }}
          >
            {label}
          </Typography>
        )}
      </IconButton>
    </CustomToolTip>
  );
};

export default CustomCopyButton;
